export enum ExportAlmMethod {
  NonMaturity = 0,
  Vintage = 1
}
